import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useEffect } from 'react'

export default async function usePostTrialApplyStepViewedEvent({
  mostQualifiedTrialApplicationIdToken,
  trialApplicationIdToken,
  type,
}: {
  mostQualifiedTrialApplicationIdToken: string
  trialApplicationIdToken: string
  type: string
}) {
  useEffect(() => {
    trackEvent(TrackingEvents.POST_TRIAL_APPLY_STEP_VIEWED, {
      mostQualifiedTrialApplicationIdToken,
      trialApplicationIdToken,
      type,
    })
  }, [])
}
